import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailers-rotating_top_banner-view';
/**
 * Event when rotating top banner is viewed. Params contain name of banner
 */
export function trackRetailersRotatingTopBannerView(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        parameters: { customParameterToken },
    });
}
